var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "comments-panel" }, [
    _c("div", { staticClass: "comments-header mb-3" }, [
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center justify-content-between mb-2",
        },
        [
          _c("h6", { staticClass: "mb-0" }, [
            _vm._v("\n        Proof Comments\n      "),
          ]),
          _vm._v(" "),
          _vm.proofInfo
            ? _c("small", { staticClass: "text-muted" }, [
                _c("i", { staticClass: "fa fa-info-circle" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.proofInfo.version_name || "Latest") +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.proofInfo
        ? _c("div", { staticClass: "alert alert-info small py-2 mb-2" }, [
            _c("i", { staticClass: "fa fa-share-alt" }),
            _vm._v("\n      Comments from shared proof page\n    "),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasProof
        ? _c("div", { staticClass: "alert alert-warning small py-2" }, [
            _c("i", { staticClass: "fa fa-exclamation-triangle" }),
            _vm._v(
              "\n      No proof generated yet. Create a proof to enable comments.\n      "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-link btn-sm d-block p-0 mt-1",
                attrs: { type: "button" },
                on: { click: _vm.openCreateProofModal },
              },
              [_vm._v("\n        Create proof\n      ")]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.hasProof
      ? _c(
          "div",
          { staticClass: "comments-filter btn-group btn-group-sm w-100 mb-3" },
          [
            _c(
              "button",
              {
                staticClass: "btn",
                class: !_vm.showResolved
                  ? "btn-primary"
                  : "btn-outline-primary",
                on: {
                  click: function ($event) {
                    _vm.showResolved = false
                  },
                },
              },
              [
                _vm._v(
                  "\n      Open Only (" + _vm._s(_vm.openCount) + ")\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn",
                class: _vm.showResolved ? "btn-primary" : "btn-outline-primary",
                on: {
                  click: function ($event) {
                    _vm.showResolved = true
                  },
                },
              },
              [_vm._v("\n      All (" + _vm._s(_vm.totalCount) + ")\n    ")]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasProof
      ? _c(
          "div",
          { staticClass: "comments-list" },
          [
            _vm.loading
              ? _c("div", { staticClass: "text-center p-3" }, [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  _vm._v(" Loading comments...\n    "),
                ])
              : _vm.filteredComments.length === 0
              ? _c("div", { staticClass: "text-center text-muted p-3" }, [
                  _c("i", { staticClass: "fa fa-comments-o fa-2x mb-2" }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.showResolved
                            ? "No comments yet"
                            : "No open comments"
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.filteredComments, function (comment) {
              return _c("CommentItem", {
                key: comment.id + "-" + _vm.selectedCommentId,
                attrs: {
                  "data-comment-id": comment.id,
                  comment: comment,
                  "show-proof-link": true,
                  "proof-share-link": _vm.proofShareLink,
                  "is-highlighted": _vm.isCommentHighlighted(comment.id),
                },
                on: {
                  reply: _vm.handleReply,
                  resolve: _vm.handleResolve,
                  resolved: _vm.handleCommentResolved,
                  approved: _vm.handleCommentApproved,
                  delete: _vm.handleDelete,
                  deleted: _vm.handleCommentDeleted,
                  edit: _vm.handleEdit,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.handleCommentClick(comment)
                  },
                },
              })
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasProof
      ? _c("div", { staticClass: "add-comment-section mt-3 pt-3 border-top" }, [
          !_vm.showCommentInput
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary w-100",
                  on: {
                    click: function ($event) {
                      _vm.showCommentInput = true
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" Add Comment\n    "),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCommentInput
            ? _c(
                "div",
                { staticClass: "simple-comment-input" },
                [
                  _vm.editingCommentId
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "alert alert-warning py-2 px-3 mb-2 d-flex justify-content-between align-items-center",
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.editingCommentId = null
                                  _vm.newCommentText = ""
                                },
                              },
                            },
                            [_c("span", [_vm._v("×")])]
                          ),
                        ]
                      )
                    : _vm.replyToCommentId
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "alert alert-info py-2 px-3 mb-2 d-flex justify-content-between align-items-center",
                        },
                        [
                          _c("small", [
                            _c("i", { staticClass: "fa fa-reply" }),
                            _vm._v(
                              " Replying to " +
                                _vm._s(_vm.replyToCommentUsername) +
                                "\n        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.replyToCommentId = null
                                },
                              },
                            },
                            [_c("span", [_vm._v("×")])]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-form-textarea", {
                    staticClass: "mb-2",
                    attrs: {
                      placeholder: "Write a comment...",
                      rows: "3",
                      disabled: _vm.submitting,
                    },
                    model: {
                      value: _vm.newCommentText,
                      callback: function ($$v) {
                        _vm.newCommentText = $$v
                      },
                      expression: "newCommentText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            size: "sm",
                            variant: "outline-secondary",
                            disabled: _vm.submitting,
                          },
                          on: { click: _vm.closeCommentInput },
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "primary",
                            disabled:
                              !_vm.newCommentText.trim() || _vm.submitting,
                          },
                          on: { click: _vm.submitComment },
                        },
                        [
                          !_vm.submitting
                            ? _c("i", { staticClass: "fa fa-check" })
                            : _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                          _vm._v(" "),
                          _vm.editingCommentId
                            ? [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.submitting ? "Updating..." : "Update"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.submitting
                                        ? "Submitting..."
                                        : "Submit"
                                    ) +
                                    "\n          "
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("small", [
      _c("i", { staticClass: "fa fa-pencil" }),
      _vm._v(" Editing comment\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }